module.exports = __webpack_public_path__ + "asana-logo-eef7af8ebd4cffd068352c455040f7fc.webp";